/* ORZO — strona eventów: zakładki okazji, szybkie zapytanie, kalkulator.
   Każdy skrót wypełnia ten sam formularz zapytania (#OrzoEventContact). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var NF = new Intl.NumberFormat(document.documentElement.lang || 'pl', { maximumFractionDigits: 0 });
  /* Rodzaj wydarzenia ustawiamy po stałej wartości opcji (value), nigdy po widocznym
     tekście — tekst zmienia się z językiem, wartość nie. Wartości opcji są w
     snippets/orzo-event-planner.liquid. */
  var TYP_MENU = { swieta: 'Wigilia firmowa', komunia: 'Przyjęcie komunijne' };
  var TYP_ZAKLADKA = {
    'Wigilia firmowa': 'wigilie', 'Przyjęcie komunijne': 'komunie', 'Chrzciny': 'komunie',
    'Urodziny dziecka': 'dzieci', 'Catering': 'catering',
    'Urodziny lub rocznica': 'rodzinne', 'Inne przyjęcie rodzinne': 'rodzinne',
    'Kolacja lub lunch firmowy': 'firmowe', 'Wynajem sali': 'firmowe', 'Inne spotkanie firmowe': 'firmowe'
  };
  var T = {};
  try { T = JSON.parse(($('[data-ev-t]') || {}).textContent || '{}'); } catch (err) { T = {}; }
  var tt = function (k, o, zapas) {
    return String(T[k] || zapas || '').replace(/\{(\w+)\}/g, function (_, x) { return o && o[x] != null ? o[x] : ''; });
  };
  var zl = function (n) { return NF.format(Math.round(n)) + ' zł'; };

  var form = $('#OrzoEventContact');
  function pole(sel) { return form ? $(sel, form) : null; }
  function zmien(el) { if (el) el.dispatchEvent(new Event('change', { bubbles: true })); }
  function ustawLokal(handle) {
    var s = pole('[data-event-venue]');
    if (!s) return;
    var o = $$('option', s).find(function (x) { return x.dataset.handle === handle; });
    if (o) { s.value = o.value; zmien(s); }
  }
  function ustawMiasto(miasto) {
    var s = pole('[data-event-venue]');
    if (!s || !miasto) return;
    var o = $$('option', s).find(function (x) { return x.value.indexOf(miasto) !== -1; });
    if (o) { s.value = o.value; zmien(s); }
  }
  function ustawTyp(typ) {
    var s = pole('[data-event-type]');
    if (!s || !typ) return;
    var o = $$('option', s).find(function (x) { return x.value === typ; }) ||
            $$('option', s).find(function (x) { return x.text === typ; });
    if (o) { s.value = o.value || o.text; zmien(s); }
  }
  function ustawGosci(n) { var i = pole('input[name="contact[Liczba gości]"]'); if (i && n) i.value = n; }
  function ustawDate(d) { var i = pole('[data-event-date]'); if (i && d) i.value = d; }
  function dopisz(tekst) {
    var t = pole('textarea[name="contact[body]"]');
    if (!t || !tekst) return;
    var baza = t.value.replace(/\n*\[(Kalkulator|Calculator)\][\s\S]*$/, '');
    t.value = baza ? baza + '\n\n' + tekst : tekst;
  }
  function doFormularza() {
    var cel = $('#zapytanie');
    if (!cel) return;
    cel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var imie = pole('input[name="contact[name]"]');
    if (imie) setTimeout(function () { imie.focus({ preventScroll: true }); }, 500);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-typ], a[data-lokal]');
    if (!a || !form) return;
    e.preventDefault();
    if (a.dataset.typ) ustawTyp(a.dataset.typ);
    if (a.dataset.lokal) ustawLokal(a.dataset.lokal);
    doFormularza();
  });

  $$('input[data-min-dzis]').forEach(function (i) {
    var d = new Date();
    i.min = [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-');
  });

  var szybko = $('[data-ev-szybko]');
  if (szybko) szybko.addEventListener('submit', function (e) {
    e.preventDefault();
    ustawMiasto(szybko.miasto.value);
    ustawDate(szybko.data.value);
    ustawGosci(szybko.goscie.value);
    doFormularza();
  });

  var tabs = $('[data-ev-tabs]');
  if (tabs) {
    var przyciski = $$('[role="tab"]', tabs);
    var pokaz = function (id, fokus) {
      przyciski.forEach(function (b) {
        var on = b.dataset.tab === id;
        b.setAttribute('aria-selected', String(on));
        b.tabIndex = on ? 0 : -1;
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
        if (on && fokus) b.focus();
      });
    };
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[role="tab"]');
      if (b) pokaz(b.dataset.tab);
    });
    tabs.addEventListener('keydown', function (e) {
      var b = e.target.closest('[role="tab"]');
      if (!b || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var i = przyciski.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1);
      i = (i + przyciski.length) % przyciski.length;
      pokaz(przyciski[i].dataset.tab, true);
    });
    /* sezon podpowiada, co otworzyć na start: jesienią wigilie, wiosną komunie */
    var m = new Date().getMonth() + 1;
    var par = new URLSearchParams(location.search);
    var typ = par.get('typ') || '';
    var start = 'firmowe';
    var wprost = par.get('zakladka') || TYP_ZAKLADKA[typ];
    if (wprost && przyciski.some(function (b) { return b.dataset.tab === wprost; })) start = wprost;
    else if (/wigilia/i.test(typ) || (!typ && (m >= 9 || m === 1))) start = 'wigilie';
    else if (/komunia|chrzciny/i.test(typ) || (!typ && m >= 3 && m <= 5)) start = 'komunie';
    else if (/dziecka/i.test(typ)) start = 'dzieci';
    else if (/catering/i.test(typ)) start = 'catering';
    else if (/urodziny|wesele|wieczór/i.test(typ)) start = 'rodzinne';
    pokaz(start);
  }

  var kalk = $('[data-ev-kalk]');
  var daneEl = $('[data-ev-dane]');
  if (kalk && daneEl) {
    var dane = {};
    try { dane = JSON.parse(daneEl.textContent); } catch (err) { dane = {}; }
    var rozbicie = $('[data-ev-rozbicie]'), suma = $('[data-ev-suma]'), salaEl = $('[data-ev-sala]');
    var outG = $('[data-out-goscie]'), wyslij = $('[data-ev-kalk-wyslij]');
    var ostatni = null;

    var przelicz = function () {
      var lok = (dane.lokale || {})[kalk.lokal.value];
      var menu = (dane.menu || {})[kalk.menu.value];
      var set = (dane.sety || {})[kalk.set.value];
      var g = +kalk.goscie.value;
      if (outG) outG.textContent = g;
      if (!lok || !menu) return;
      var cena = (lok.prog === 'B' && menu.b) ? menu.b : menu.a;
      var zaMenu = cena * g;
      var zaNapoje = set ? set.cena * g : 0;
      var serwis = menu.serwis ? (zaMenu + zaNapoje) * menu.serwis / 100 : 0;
      var razem = zaMenu + zaNapoje + serwis;
      var wiersze = [[tt('menu', null, 'Menu'), g + ' × ' + zl(cena), zl(zaMenu)]];
      if (set) wiersze.push([tt('napoje', { set: set.nazwa }, set.nazwa), g + ' × ' + zl(set.cena), zl(zaNapoje)]);
      if (serwis) wiersze.push([tt('serwis', { n: menu.serwis }, menu.serwis + '%'), '', zl(serwis)]);
      rozbicie.innerHTML = '';
      wiersze.forEach(function (w) {
        var d = document.createElement('div');
        var dt = document.createElement('dt'); dt.textContent = w[0];
        var dd = document.createElement('dd');
        var s1 = document.createElement('span'); s1.textContent = w[1];
        var s2 = document.createElement('b'); s2.textContent = w[2];
        dd.appendChild(s1); dd.appendChild(s2); d.appendChild(dt); d.appendChild(dd);
        rozbicie.appendChild(d);
      });
      var jedn = tt(menu.jedn === 'brutto' ? 'brutto' : 'netto', null, menu.jedn);
      suma.textContent = zl(razem) + ' ' + jedn;
      var pasuje = (lok.sale || []).filter(function (s) { return s.p >= g; }).sort(function (a, b) { return a.p - b.p; })[0];
      var max = Math.max.apply(null, (lok.sale || []).map(function (s) { return s.p; }).concat([0]));
      salaEl.textContent = pasuje
        ? tt(pasuje.caly ? 'caly' : 'sala', { lokal: lok.nazwa, sala: pasuje.n, n: pasuje.p }, lok.nazwa + ': ' + pasuje.n + ' (' + pasuje.p + ')')
        : tt('brak', { lokal: lok.nazwa, n: max }, lok.nazwa + ': max ' + max);
      ostatni = { lok: kalk.lokal.value, g: g, menu: menu, set: set, razem: razem, sala: pasuje, jedn: jedn };
    };
    kalk.addEventListener('input', przelicz);
    kalk.addEventListener('change', przelicz);
    /* lokal z linku (np. rezerwacja 8+) ustawiamy też w kalkulatorze, nie tylko w formularzu */
    var lokZLinku = new URLSearchParams(location.search).get('lokal');
    if (lokZLinku && kalk.lokal && $$('option', kalk.lokal).some(function (o) { return o.value === lokZLinku; })) kalk.lokal.value = lokZLinku;
    przelicz();

    $$('a[data-kalk]').forEach(function (a) {
      a.addEventListener('click', function () {
        var typ = a.dataset.kalk;
        var o = $$('option', kalk.menu).find(function (x) { var mm = (dane.menu || {})[x.value]; return mm && mm.typ === typ; });
        if (o) { kalk.menu.value = o.value; przelicz(); }
      });
    });

    if (wyslij) wyslij.addEventListener('click', function (e) {
      e.preventDefault();
      if (!ostatni || !form) return;
      ustawLokal(ostatni.lok);
      ustawGosci(ostatni.g);
      if (TYP_MENU[ostatni.menu.typ]) ustawTyp(TYP_MENU[ostatni.menu.typ]);
      dopisz(tt('notka', {
        menu: ostatni.menu.nazwa,
        set: ostatni.set ? ', ' + ostatni.set.nazwa : '',
        g: ostatni.g,
        suma: zl(ostatni.razem),
        jedn: ostatni.jedn,
        sala: ostatni.sala ? ', ' + ostatni.sala.n : ''
      }, '[Kalkulator] ' + ostatni.menu.nazwa + ', ' + ostatni.g + ', ' + zl(ostatni.razem)));
      doFormularza();
    });
  }
}());
